import React, { Component, PureComponent } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"

import PieChart from 'react-minimal-pie-chart';
import Stringify from 'react-stringify'

  import api from "../../services/api"
  import "../../assets/styleadmin.css"


class IndexAdmin extends Component {

    state = {
        matriculas:[],
        search:null,
        faturas:[],
        ano:parseInt(this.props.match.params.year),
    
      }
    async UNSAFE_componentWillMount()
    {


      
        this.loadmatriculas();
        this.loadfaturas();
    
    
      }



      async loadfaturas(){
        const {ano} = this.state;
        const response = await api.post("/admin/relatorio/faturassemestral", {ano});
    
        this.setState({
          faturas:response.data
        })

        localStorage.setItem('datarelatfatpaga',this.state.faturas.paga)
        localStorage.setItem('datarelatfatnaopaga',this.state.faturas.naopaga)
        localStorage.setItem('datarelatfatcancelada',this.state.faturas.cancelado)
        localStorage.setItem('datarelatfatreembolsada',this.state.faturas.refund)
        localStorage.setItem('datarelatfattotal',this.state.faturas.total)

        window.reloadfat();
      }



      async loadmatriculas(){

        const {ano} = this.state;
        const response = await api.post("/admin/relatorio/matriculasemestral",{ano});
    
        this.setState({
          matriculas:response.data
        })

        localStorage.setItem('matpaga',this.state.matriculas.paga)
        localStorage.setItem('matnaopaga',this.state.matriculas.naopaga)
        localStorage.setItem('mattotal',this.state.matriculas.total)
        window.reloadmat();

      }

  render() {
    
  
    
    return (
      <React.Fragment>
          <Header />
          <div class="col-lg-12">
          <center><h4>Relatório do Atual Semestre</h4></center>
          <br />
          
          <center>
          <label class="form-control">Ano Atuação</label>
          <select class="form-control" onChange={e => this.setState({ ano: parseInt(e.target.value) })}>
              <option value={2019} selected={this.state.ano==2019}>2019</option>
              <option value={2020} selected={this.state.ano==2020}>2020</option>
              <option value={2021} selected={this.state.ano==2021}>2021</option>
              <option value={2022} selected={this.state.ano==2022}>2022</option>
              <option value={2023} selected={this.state.ano==2023}>2023</option>
              <option value={2024} selected={this.state.ano==2024}>2024</option>
              <option value={2025} selected={this.state.ano==2025}>2025</option>
              <option value={2026} selected={this.state.ano==2026}>2026</option>
            </select>
            <br></br>

            <a class="btn btn-danger" href={"/admin/relatorio/semestral/"+this.state.ano}>Recarregar</a>
          </center>
          <br />

          <div class="row">
              <div class="col d-flex justify-content-center">
                <div id="piechart"></div>
              </div>

              <div class="col d-flex justify-content-center">
                <div id="chart_div"></div>
              </div>
          </div>

          
          


          </div>

      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/relatoriosemestral.js